<template>
  <div class="switch">
    <div class="switch__item" :class="active === 'list' && 'active'" @click="$emit('change', 'list')">List</div>
    <div class="switch__item" :class="active === 'case map' && 'active'" @click="$emit('change', 'case map')">Case Map</div>
  </div>
</template>

<script>
export default {
  props: ['active']
};
</script>

<style lang="scss">
  .switch {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 5px;
    border: 1px solid rgba(#e0f2fc, .5);
    &__item {
      position: relative;
      height: 35px;
      width: 120px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-size: 16px;
      font-weight: 400;
      transition: .3s;
      z-index: 1;
      cursor: pointer;
      &:before {
        content: "";
        position: absolute;
        top: -1px;
        right: -1px;
        bottom: -1px;
        left: -1px;
        z-index: -1;
        transition: .3s;
        border-radius: 5px;
      }
      &.active {
        color: #07244b;
        font-weight: 700;
        &:before {
          background-color: #fff;
        }
      }
    }
  }
</style>
